import _ from "lodash"
import * as Types from "../index"
import TypeDynamic from "./TypeDynamic"
import TypeNestedMultiField from "./TypeNestedMultiField"
import { classNames } from "primereact/utils"
import styles from "../../../styles/Form-MultiBlock.module.css"

export default function MFBuilder(props) {
  const { fields, mfFieldName, mfIndex } = props

  const handleMFTypes = () => {
    // Sort "field" so that we get "normal" fields, then textarea & textarea_rich, then multi_field_nested
    const sortedFields = [...fields].sort((a, b) => {
      const order = {
        sys: 1,
        dynamic: 1,
        text: 1,
        radio: 1,
        dropdown: 1,
        phone: 1,
        checkbox: 1,
        number: 1,
        email: 1,
        date: 1,
        dropdown_us_states: 1,
        textarea: 2,
        textarea_rich: 3,
        multi_field_nested: 4,
      }
      return (order[a.field_type] || 99) - (order[b.field_type] || 99)
    })

    return _.map(sortedFields, (field, index) => {
      // Exclude date_created from rendering
      if (field.field_name === "date_created") return null

      if (field.field_type === "multi_field_nested") {
        return (
          <div key={field.field_name} className={styles.fieldContainerFullWidth}>
            <TypeNestedMultiField
              field={field}
              mfIndex={mfIndex}
              mfFieldName={mfFieldName}
              index={index}
            />
          </div>
        )
      }

      const newProps = {
        type: "multi-field",
        field,
        mfIndex,
        mfFieldName,
      }

      switch (field.field_type) {
        case "sys":
          return <Types.TypeSys {...newProps} key={field.field_name} />
        case "dynamic":
          return <TypeDynamic {...newProps} key={field.field_name} />
        case "text":
          return <Types.TypeText {...newProps} key={field.field_name} />
        case "textarea":
          return (
            <div key={field.field_name} className={styles.fieldContainerFullWidth}>
              <Types.TypeTextarea {...newProps} />
            </div>
          )
        case "textarea_rich":
          return (
            <div key={field.field_name} className={styles.fieldContainerFullWidth}>
              <Types.TypeTextareaRich {...newProps} />
            </div>
          )
        case "radio":
          return <Types.TypeRadio {...newProps} key={field.field_name} />
        case "dropdown":
          return <Types.TypeDropdown {...newProps} key={field.field_name} />
        case "phone":
          return <Types.TypeTel {...newProps} key={field.field_name} />
        case "checkbox":
          return <Types.TypeCheckbox {...newProps} key={field.field_name} />
        case "number":
          return <Types.TypeNumber {...newProps} key={field.field_name} />
        case "email":
          return <Types.TypeEmail {...newProps} key={field.field_name} />
        case "date":
          return <Types.TypeDate {...newProps} key={field.field_name} />
        case "dropdown_us_states":
          return (
            <Types.TypeDropdownUsState {...newProps} key={field.field_name} />
          )
        default:
          return null
      }
    })
  }

  return (
    <div className={classNames(styles.block, styles.fieldContainer, styles.inputFieldContainer)}>
      {handleMFTypes()}
    </div>
  )
}
